<app-ui-main-menu>
  <mat-card>
    <mat-card-header>
      <mat-card-title>Assinatura</mat-card-title>
      <button mat-stroked-button class="header-refresh" *ngIf="showRefresh" (click)="onRefresh()"
        aria-label="Buscar/Atualizar Assinatura">
        <fa-icon [icon]="'rotate-right'"></fa-icon>
        <span class="refresh-label">Sincronizar assinatura</span>
      </button>
    </mat-card-header>

    <mat-divider></mat-divider>

    <app-loading *ngIf="loading"></app-loading>

    <mat-card-content *ngIf="!loading && signature">
      <h1>Detalhes da Assinatura</h1>

      <div class="subscription-details-container">
        <div class="col-12 col-md-10 col-lg-8 col-xl-5 subscription-box">
          <div class="subscription-details-box">
            <div class="subscription-details-name">
              <span>{{ signature.plan?.name }}</span>
              <div class="subscription-status" [ngClass]="
                  subscriptionStatus === 'Ativa' ||
                  subscriptionStatus === 'Experimental'
                    ? 'active'
                    : 'inactive'
                ">
                {{ subscriptionStatus }}
              </div>
            </div>

            <div class="subscription-details-date">
              <div class="subscription-date">
                <div class="subscription-date-title">
                  <fa-icon [icon]="'calendar'"></fa-icon>
                  <p>Início em:</p>
                </div>
                <span>{{ signature.startedAt + 'T00:00:00' | date: 'DD/MM/YYYY' }}</span>
              </div>

              <div class="subscription-date">
                <div class="subscription-date-title">
                  <fa-icon [icon]="'calendar'"></fa-icon>
                  <p>Disponível até:</p>
                </div>
                <span>{{ signature.finishedAt + 'T00:00:00' | date: 'DD/MM/YYYY' }}</span>
              </div>

              <div class="subscription-date">
                <div class="subscription-date-title">
                  <fa-icon [icon]="'hourglass-half'"></fa-icon>
                  <p>Encerra em:</p>
                </div>
                <span>{{ subscriptionEndDayString }}</span>
              </div>
            </div>

            <div class="subscription-actions">
              <button mat-button class="btn-renew" *ngIf="canRenew" (click)="openRenew()">
                Renovar assinatura
              </button>
              <button mat-button class="btn-sales" (click)="openSales()">
                Falar com um especialista
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>

    <mat-card-content *ngIf="!loading && !signature">
      <div class="no-subscription">
        <h3>
          Sua assinatura pode estar em atualização. Se já contratou, aguarde alguns instantes ou fale com nossa equipe.  
          Caso ainda não tenha uma assinatura, escolha o seu plano abaixo.
        </h3>
      </div>

      <h1>Escolha seu Plano</h1>

      <div class="planSchema" *ngIf="offerPlans?.length; else notFoundMessage">
        <div *ngFor="let plan of offerPlans">
          <app-pricing-card [planName]="plan.name" [planValue]="plan.prices[0]?.price" [maxUsers]="plan.userLimit"
            [scheduleAndSupportPriority]="plan.isSupportPriorityString"
            [maxAppointmentsPerYear]="plan.indicationLimitString"
            [OccupationalHealthAndMedicalExpertise]="plan.consultations[0]?.price"
            [OthersAreas]="plan.consultations[1]?.price">
            <div class="btn-div">
              <button mat-button class="btn" (click)="goToPlan(plan.digitalManagerOffer?.link)">
                Assinar agora
              </button>
            </div>
          </app-pricing-card>
        </div>
      </div>

      <div class="actions" *ngIf="offerPlans?.length">
        <button mat-button class="btn-sales--not-found" (click)="openSales()">
          Falar com um Especialista
        </button>
      </div>

      <ng-template #notFoundMessage>
        <div class="no-subscription">
          <h3>
            Sua assinatura pode estar em fase de atualização. Se já realizou a
            contratação, aguarde alguns instantes ou fale com nossa equipe.
          </h3>
        </div>

        <div class="actions">
          <button mat-button class="btn-sales--not-found" (click)="openSales()">
            Falar com a equipe de vendas
          </button>
        </div>
      </ng-template>

      <div style="display:flex;justify-content:center;margin-top:8px" *ngIf="offerPlans?.length">
        <p>
          <b>Nota:</b> Os valores apresentados correspondem à parcela mensal do plano anual, divididos em 12 vezes no
          pagamento.
        </p>
      </div>
    </mat-card-content>
  </mat-card>
</app-ui-main-menu>